<a [href]="espaceClientUrl" [class]="class()">{{text()}}</a>
